import {API_ADMIN_URL, ANALYSER_URL} from "../../config/constants";
import { postRequest } from '../API'
/*********************************************************
* Function Name : list
* Description   : Get list of transaction  
* By            : Afsar Ali
* Date          : 29-05-2025
*********************************************************/
export const createWinners = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}winners/create-winner`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result, count: res?.data?.response?.count,};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function


/*********************************************************
* Function Name : analizeWinners
* Description   : this function is used to analyse users
* By            : Afsar Ali
* Date          : 22-03-20245
*********************************************************/
export const analizeWinners = async (options) =>{
    try {
        const params = {
            url : `${ANALYSER_URL}./analyzersingle-match`,
            // url : `https://85.13.220.166:50100/analyzersingle-match`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
           return {status : true, result : {finaldata : res?.data?.data || []}};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : analyzeWinnersList
* Description   : this function is used to analyse users
* By            : Afsar Ali
* Date          : 16-04-2025
*********************************************************/
export const analyzeWinnersList = async (options) =>{
    try {
        const params = {
            url : `${ANALYSER_URL}./analyzersingle-match`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {
                status : true, 
                result : { 
                    finaldata : res?.data?.data || [],
                    total_data : res?.data?.total_data || 0,
                    total_pages : res?.data?.total_pages || 0,
                    current_page : res?.data?.current_page || 1,
                    total_ticket : res?.data?.total_ticket || res?.data?.data[0]?.total_ticket || 0
                }
            };
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function


/*********************************************************
* Function Name : getOrderReports
* Description   : upload Lotto winner
* By            : Afsar Ali
* Date          : 22-04-2024 
*********************************************************/
export const getOrderReports = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}campaign/order-reports`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function

/*********************************************************
* Function Name : sentAnalyserEmail
* By            : Afsar Ali
* Date          : 13-09-2025 
*********************************************************/
export const sentAnalyserEmail = async (options) =>{
    try {
        const params = {
            url : `${API_ADMIN_URL}common/sent-analyser-mail`,
            postData : options
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return {status : true, result : res?.data?.response?.result};
        } else{
            return {status : false, message:res?.response?.data?.statusMessage}
        }
    } catch (error) {
        console.log(error)
        return {status : false, message:"Under Maintenance, Please try after some time."}
    }
};//End of Function